import JavascriptSnippetSettings from "./JavascriptSnippetSettings";

export default JavascriptSnippetSettings;
